import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-zinc-950 text-white p-8">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-amber-500 hover:text-amber-400 mb-8">
          <ArrowLeft size={20} />
          Back to Studio
        </Link>
        
        <img 
          src="https://customer-assets.emergentagent.com/job_ai-command-hub-48/artifacts/opkezy5x_CB3D4111-0127-441A-AEB4-FB146D6CBB1E.PNG" 
          alt="IPVALUE Managements"
          className="h-20 mb-8"
        />
        
        <h1 className="text-4xl font-bold mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Privacy Policy
        </h1>
        
        <p className="text-zinc-400 mb-4">Last updated: March 2024</p>
        
        <div className="prose prose-invert max-w-none space-y-6 text-zinc-300">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">1. Introduction</h2>
            <p>
              IPVALUE Managements Group ("we", "our", or "us") operates IPVALUE AI Studio. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your 
              information when you use our Service.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">2. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Account Information:</strong> Name, email address, and login credentials</li>
              <li><strong>Content Data:</strong> Lessons, posts, and media you create using the Service</li>
              <li><strong>Usage Data:</strong> Information about how you interact with the Service</li>
              <li><strong>Third-Party Data:</strong> Information from connected platforms (TikTok, Instagram, etc.)</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">3. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Provide and maintain the Service</li>
              <li>Process your content creation and publishing requests</li>
              <li>Connect with third-party platforms on your behalf</li>
              <li>Improve and personalize your experience</li>
              <li>Communicate with you about the Service</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">4. Third-Party Services</h2>
            <p>
              Our Service integrates with third-party platforms including TikTok, Instagram, 
              YouTube, Facebook, LinkedIn, Twitter/X, ElevenLabs, Whop, and Stripe. When you 
              connect these services, we may access and store certain information from these 
              platforms as authorized by you. Each third-party service has its own privacy policy 
              governing the use of your information.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect 
              your personal information. However, no method of transmission over the Internet or 
              electronic storage is 100% secure.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">6. Data Retention</h2>
            <p>
              We retain your personal information for as long as your account is active or as 
              needed to provide you with the Service. You may request deletion of your account 
              and associated data at any time.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">7. Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Access your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
            </ul>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">8. Cookies</h2>
            <p>
              We use cookies and similar tracking technologies to track activity on our Service 
              and hold certain information. You can instruct your browser to refuse all cookies 
              or to indicate when a cookie is being sent.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">9. Children's Privacy</h2>
            <p>
              Our Service is not intended for use by children under the age of 13. We do not 
              knowingly collect personal information from children under 13.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any 
              changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-3">11. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us at:<br />
              <strong>IPVALUE Managements Group</strong><br />
              Email: privacy@ipvaluemanagements.com
            </p>
          </section>
        </div>
        
        <div className="mt-12 pt-8 border-t border-zinc-800 text-center text-zinc-500 text-sm">
          © 2024 IPVALUE Managements Group. All rights reserved.
        </div>
      </div>
    </div>
  );
}
